import { api } from '@/lib/api';
import type {
  AdminMonthlyReportRow,
  MonthlyReport,
  MonthlyReportStatus,
  PresignedPdfUrl,
} from './types';

export const monthlyReportsService = {
  listForVessel: async (vesselId: string): Promise<MonthlyReport[]> => {
    const { data } = await api.get<MonthlyReport[]>(
      `/vessels/${vesselId}/monthly-reports`,
    );
    return data;
  },

  getPdfUrl: async (
    vesselId: string,
    periodYear: number,
    periodMonth: number,
  ): Promise<PresignedPdfUrl> => {
    const { data } = await api.get<PresignedPdfUrl>(
      `/vessels/${vesselId}/monthly-reports/${periodYear}/${periodMonth}/pdf-url`,
    );
    return data;
  },

  generate: async (
    vesselId: string,
    input: { periodYear: number; periodMonth: number },
  ): Promise<MonthlyReport> => {
    const { data } = await api.post<MonthlyReport>(
      `/vessels/${vesselId}/monthly-reports/generate`,
      input,
    );
    return data;
  },

  adminList: async (
    status?: MonthlyReportStatus,
  ): Promise<AdminMonthlyReportRow[]> => {
    const { data } = await api.get<AdminMonthlyReportRow[]>(
      '/admin/monthly-reports',
      { params: status ? { status } : {} },
    );
    return data;
  },
};
